import { createSlice } from "@reduxjs/toolkit";
import { getRecaptchaKey, toLogin } from "../actions/login.actions";

const initialState = {
  recaptchaKey: {} as any,
  login: {} as any,
  loading: false,
  error: null as unknown | null,
};
export const loginSlice = createSlice({
  name: "login",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getRecaptchaKey.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRecaptchaKey.fulfilled, (state, action) => {
        state.recaptchaKey = action.payload;
        state.loading = false;
      })
      .addCase(getRecaptchaKey.rejected, (state, action) => {
        state.recaptchaKey = {};
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(toLogin.pending, (state) => {
        state.loading = true;
      })
      .addCase(toLogin.fulfilled, (state, action) => {
        state.login = action.payload;
        state.loading = false;
      })
      .addCase(toLogin.rejected, (state, action) => {
        state.login = {};
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default loginSlice.reducer;
